
import FlexibleSectionMixin from '~/mixins/flexible-section';

export default {
    mixins: [
        FlexibleSectionMixin
    ],

    props: {
        images: {
            type: Array,
            default: null
        },
        imageAspectRatio: {
            type: String,
            default: 'original',
            validator(value) {
                return ['original', '1:1'].includes(value);
            }
        },
        sectionWidth: {
            type: String,
            default: 'page',
            validator(value) {
                return ['page', 'content', 'content-center'].includes(value);
            }
        }
    }
};
